import { CdkScrollable } from "@angular/cdk/scrolling";
import { Component, OnInit, inject } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCard, MatCardContent, MatCardHeader, MatCardTitle } from "@angular/material/card";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { MatProgressBar } from "@angular/material/progress-bar";
import { FlexDirective, LayoutAlignDirective } from "@ngbracket/ngx-layout/flex";
import { Command, CommandBarComponent, LabelCommand } from "@tylertech/commands-module";
import { AugmentedModelObject, MetadataPanelComponent } from "@tylertech/metadata-module";
import { ClassMetadata } from "@tylertech/tyler-api-types";
import { JournalEntryService } from "../../services";

export interface JournalEntryReceiptDialogData
{
    readonly JEReceipt: AugmentedModelObject;
}

@Component({
    selector: "journal-entry-receipt-dialog-component",
    templateUrl: "./journalEntryReceiptDialog.tmpl.html",
    imports: [
        CdkScrollable,
        CommandBarComponent,
        FlexDirective,
        LayoutAlignDirective,
        FormsModule,
        MatCard,
        MatCardContent,
        MatCardHeader,
        MatCardTitle,
        MatDialogActions,
        MatDialogContent,
        MatDialogTitle,
        MatProgressBar,
        MetadataPanelComponent,
        ReactiveFormsModule,
    ]
})
export class JournalEntryReceiptDialogComponent implements OnInit
{
    private readonly dialogRef = inject<MatDialogRef<JournalEntryReceiptDialogComponent, AugmentedModelObject | void>>(MatDialogRef);
    private readonly data = inject<JournalEntryReceiptDialogData>(MAT_DIALOG_DATA);
    private readonly $glJournalEntryService = inject(JournalEntryService);

    readonly commands: ReadonlyArray<Command>;
    isLoaded: boolean;
    journalEntryCashTransactionsMetadata: ClassMetadata;
    journalEntryReceiptMetadata: ClassMetadata;
    metadataModel: AugmentedModelObject;
    constructor()
    {
        this.commands = [
            new LabelCommand({
                label: "Cancel",
                action: () => this.dialogRef.close(),
                getEnabled: () => true,
            }),
            new LabelCommand({
                label: "Save",
                action: () => this.saveReceipt(),
                getEnabled: () => true,
            }),
        ];
    }

    private get JEReceipt(): AugmentedModelObject
    {
        return this.data.JEReceipt;
    }

    ngOnInit(): void
    {
        this.metadataModel = Object.assign({}, this.JEReceipt) as AugmentedModelObject;
        Promise.all([
            this.$glJournalEntryService.GetGLJournalEntryDistributionReceiptViewMetadata().then(metadata =>
            {
                this.journalEntryReceiptMetadata = metadata;
            }),
            this.$glJournalEntryService.GetGLJournalEntryDistributionCashTransactionsViewMetadata().then(metadata =>
            {
                this.journalEntryCashTransactionsMetadata = metadata;
            }),
        ]).finally(() =>
        {
            this.isLoaded = true;
        });
    }

    private saveReceipt(): void
    {
        this.dialogRef.close(this.metadataModel);
    }
}
